import request from '@/utils/request'
import appRequest from "@/utils/appRequest";

// 邮箱注册
export function emailRegister(email, password, emailCode,language) {
    const data = {
        email,
        password,
        emailCode,
        language,
    }
    return appRequest({
        url: '/yuzhen/register/email',
        method: 'post',
        data: data
    })
}

// 邮箱注册验证码
export function sendEmailCode(email,language) {
    const data = {
        email,
        language
    }
    return appRequest({
        url: '/yuzhen/register/email/code',
        method: 'post',
        data: data
    })
}

// 邮箱重置密码验证码
export function sendEmailResetCode(email,language) {
    const data = {
        email,
        language
    }
    return appRequest({
        url: '/yuzhen/register/email/reset/code',
        method: 'post',
        data: data
    })
}

// 邮箱重置密码
export function emailReset(email, password, emailCode,language) {
    const data = {
        email,
        password,
        emailCode,
        language
    }
    return appRequest({
        url: '/yuzhen/register/reset/account/password',
        method: 'post',
        data: data
    })
}

// 获取注册奖励信息
export function getRegisterAward() {
    return appRequest({
        url: '/yuzhen/register/newuser/award',
        method: 'get',
    })
}

// 加盟与真
export function joinYuzhen(email,language) {
    const data = {
        email,
        language
    }
    return appRequest({
        url: '/yuzhen/register/join/yuzhen',
        method: 'post',
        data: data
    })
}


